import React from 'react';

const transformations = [
  {
    category: 'Task Completion',
    before: { value: '3', label: 'tasks/week' },
    after: { value: '15', label: 'tasks/week' },
    improvement: '5×'
  },
  {
    category: 'Consistency',
    before: { value: '0', label: 'day streak' },
    after: { value: '21', label: 'day streak' },
    improvement: '+21 days'
  },
  {
    category: 'Commitment Rate',
    before: { value: '40%', label: 'follow-through' },
    after: { value: '87%', label: 'follow-through' },
    improvement: '+117%'
  },
  {
    category: 'Deep Focus Time',
    before: { value: '2h', label: 'focused/day' },
    after: { value: '5.5h', label: 'focused/day' },
    improvement: '2.75×'
  }
];

const BeforeAfter = () => {
  return (
    <section className="relative py-32 px-6 lg:px-12" style={{ background: '#050508' }}>
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section header */}
        <div className="text-center mb-20 reveal">
          <div className="section-label">Results</div>
          <h2 className="text-4xl lg:text-6xl font-black tracking-tight mb-5">
            Before & After{' '}
            <span className="gradient-text">TickBoom</span>
          </h2>
          <p className="text-lg text-[rgba(255,255,255,0.4)] max-w-xl mx-auto">
            Average results from users who committed to TickBoom for 30 days.
          </p>
        </div>

        {/* Stats grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {transformations.map((item, index) => (
            <div key={index} className={`cyber-card p-7 reveal delay-${index * 100 + 100}`}>
              {/* Category */}
              <div className="text-xs font-mono font-medium uppercase tracking-widest text-[#6b7280] mb-6">
                {item.category}
              </div>

              {/* Before */}
              <div className="mb-4 pb-4 border-b border-[rgba(255,255,255,0.06)]">
                <div className="text-xs uppercase tracking-wider text-[#6b7280] mb-1.5 font-mono">Before</div>
                <span className="text-2xl font-bold text-[rgba(255,255,255,0.2)] line-through font-mono">
                  {item.before.value}
                </span>
                <span className="text-sm text-[#6b7280] ml-1.5">{item.before.label}</span>
              </div>

              {/* After */}
              <div className="mb-5">
                <div className="text-xs uppercase tracking-wider gradient-text mb-1.5 font-mono">After</div>
                <span className="text-4xl font-bold text-white font-mono">{item.after.value}</span>
                <span className="text-sm text-[rgba(255,255,255,0.45)] ml-1.5">{item.after.label}</span>
              </div>

              {/* Badge */}
              <div className="inline-block px-3 py-1.5 rounded-lg text-xs font-mono font-bold gradient-text bg-[rgba(124,58,237,0.08)] border border-[rgba(124,58,237,0.2)]">
                {item.improvement}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center mt-8 text-xs text-[#6b7280] font-mono">
          Based on aggregated user data. Individual results may vary.
        </p>
      </div>
    </section>
  );
};

export default BeforeAfter;
